import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class SidebarComponent extends Component {
    @service router;

    menuItems = [
        { label: 'Dashboard', iconClass: 'far fa-chart-bar', route: 'bienvenida' },
        { label: 'Marcaje', iconClass: 'far fa-clock', route: 'bienvenida' },
        { label: 'Configuración', iconClass: 'far fa-circle-dot', route: 'bienvenida' },
        { separator: true },
        { label: 'Gestiones', iconClass: 'far fa-clipboard', route: 'gestiones' },
        { label: 'Calendario', iconClass: 'far fa-calendar', route: 'bienvenida' },
        { label: 'Empleados', iconClass: 'far fa-address-book', route: 'bienvenida' },
        { label: 'Planilla', iconClass: 'far fa-file-lines', route: 'bienvenida' },
        { label: 'Registro de gestiones', iconClass: 'far fa-file-alt', route: 'bienvenida' },
        { label: 'Recursos', iconClass: 'far fa-folder-open', route: 'bienvenida' },
    ];

    @action
    navigateTo(route) {
        this.router.transitionTo(route);
    }
}
